import { productData, productTypes } from "../../data";
import * as actionTypes from "./actionTypes";
import { firebase } from "../../firebase/index";
import { collections } from "../../firebase/firestoreNameSpaces";
export const updateCategoryName = (categoryName) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CATEGORYNAME,
      payload: { categoryName: categoryName },
    });
  };
};

export const updateCategoryType = (categoryType) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CATEGORYTYPE,
      payload: { categoryType: categoryType },
    });
  };
};

//this doesnt have actionTypes & reducer
export const returnSpecificProducts = (
  categoryId,
  subcategoryId,
  productType,
  shop
) => {
  // console.log(categoryId,subcategoryId,productType,shop)
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      try {
        let db = firebase.firestore();
        let limit = getState().categoryProducts.limit;
        db.collection(collections.PRODUCTS)
          .where("categoryId", "==", categoryId)
          .where("subcategoryId", "==", subcategoryId)
          .where("productTypeId", "==", productType)
          .limit(limit)
          .get()
          .then((snapshot) => {
            if (snapshot.size) {
              let products = [];
              snapshot.forEach((doc) => {
                products.push(doc.data());
              });

              let lastDoc = snapshot.docs[snapshot.size - 1];

              dispatch({
                type: actionTypes.CATEGORY_PRODUCTS_CONTROLS,
                payload: {
                  lastDoc: lastDoc,
                  leadsexhausted: snapshot.size < limit ? true : false,
                },
              });

              resolve(products);
            } else {
              dispatch({
                type: actionTypes.CATEGORY_PRODUCTS_CONTROLS,
                payload: {
                  leadsexhausted: snapshot.size < limit ? true : false,
                },
              });

              resolve([]);
            }
          });
      } catch (error) {
        reject(error);
        return alert(error);
      }
    });
  };
};

export const loadMoreCategoryProducts = (
  categoryId,
  subcategoryId,
  productType,
  shop,
  leadsexhausted,
  lastDoc,
  limit
) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      try {
        if (leadsexhausted) {
          return reject(false);
          // return alert("Leads Exhausted");
        }

        let db = firebase.firestore();

        db.collection(collections.PRODUCTS)
          .where("categoryId", "==", categoryId)
          .where("subcategoryId", "==", subcategoryId)
          .where("productTypeId", "==", productType)
          .startAfter(lastDoc)
          .limit(limit)
          .get()
          .then((snapshot) => {
            if (snapshot.size) {
              let products = [];
              snapshot.forEach((doc) => {
                products.push(doc.data());
              });

              let lastDoc = snapshot.docs[snapshot.size - 1];

              dispatch({
                type: actionTypes.CATEGORY_PRODUCTS_CONTROLS,
                payload: {
                  lastDoc: lastDoc,
                  leadsexhausted: snapshot.size < limit ? true : false,
                },
              });

              resolve(products);
            } else {
              dispatch({
                type: actionTypes.CATEGORY_PRODUCTS_CONTROLS,
                payload: {
                  leadsexhausted: snapshot.size < limit ? true : false,
                },
              });
              resolve([]);
            }
          });
      } catch (error) {
        reject(error);
        return alert(error);
      }
    });
  };
};

export const getCategoryTypeList = () => {
  return (dispatch) => {
    // setTimeout(() => {
    //     let categoryTypeList = productTypes
    //     dispatch({ type: actionTypes.UPDATE_CATEGORYTYPE, payload: { categoryTypeList: categoryTypeList } })
    // }, 1000);
    let categoryTypeList = productTypes;
    dispatch({
      type: actionTypes.UPDATE_CATEGORYTYPE,
      payload: { categoryTypeList: categoryTypeList },
    });
  };
};
